var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.209 52.209",
    style: {
      enableBackground: "new 0 0 52.209 52.209"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2D5D7"
    },
    d: "M26,29.237H2c-1.105,0-2-1.896-2-3v-2c0-1.104,0.895-1,2-1h48c1.104,0,2-0.104,2,1v2 c0,1.104-0.896,3-2,3h-7H26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2D5D7"
    },
    d: "M52.209,28.237c0,12-11.641,23.001-26,23.001c-14.36,0-26.001-11.001-26.001-23.001H52.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A5"
    },
    d: "M25.269,48.461c-0.034,0-0.068-0.002-0.103-0.005c-5.875-0.603-11.267-2.938-15.182-6.577 c-0.405-0.376-0.428-1.009-0.052-1.413c0.376-0.404,1.01-0.426,1.413-0.052c3.599,3.345,8.58,5.494,14.025,6.052 c0.549,0.057,0.949,0.548,0.893,1.097C26.209,48.078,25.775,48.461,25.269,48.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A5"
    },
    d: "M7.416,38.968c-0.238,0-0.477-0.085-0.668-0.257c-0.435-0.391-0.834-0.828-1.188-1.302 c-0.331-0.441-0.241-1.068,0.202-1.399c0.443-0.332,1.069-0.24,1.4,0.202c0.275,0.368,0.586,0.709,0.924,1.013 c0.411,0.369,0.444,1.001,0.075,1.412C7.962,38.856,7.69,38.968,7.416,38.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5BB"
    },
    d: "M27,23.237v8.918c0,1.369,1.13,2.479,2.5,2.479c1.369,0,2.5-1.109,2.5-2.479v-1.72v-0.76 c0-1.37,1.13-2.479,2.5-2.479c1.369,0,2.5,1.109,2.5,2.479v6.551v1.714c0,1.369,1.131,2.479,2.5,2.479c1.369,0,2.5-1.109,2.5-2.479 V23.098v0.139H27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M25.829,23.237L4.74,1.648c-0.716-0.715-1.876-0.965-2.593-0.25l-0.235,0.11 c-0.716,0.716-0.716,2.314,0,3.03l18.26,18.698H25.829z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunch);
export default __webpack_public_path__ + "static/media/lunch.d9cfaa831068a7c4c6e0950501ebcd0d.svg";
export { ForwardRef as ReactComponent };